<template>
  <v-app id="improve" :class="[$globalConfig.APP_NAME == 'senso' ? 'edify' : 'improve']">
    <!-- Consent for the public pages, a bar above the page that pushes it down
         rather than covering it; it shows itself only where it applies. -->
    <cookie-banner></cookie-banner>
    <router-view />
    <!-- The IMPROVE Live webinar booking popup, over any page (trial admins). -->
    <webinar-booking-dialog v-if="$store.getters.isLoggedIn"></webinar-booking-dialog>
    <vue-snotify></vue-snotify>
  </v-app>
</template>

<script>
import WebinarBookingDialog from "@/components/WebinarBookingDialog";
import CookieBanner from "@/components/CookieBanner";

export default {
  name: "App",
  components: {
    WebinarBookingDialog,
    CookieBanner,
  },
  data () {
    return {
      timeoutID: ''
    }
  },
  methods: {
    // setup() {
    //   document.addEventListener("mousemove", this.resetTimer, false);
    //   document.addEventListener("mousedown", this.resetTimer, false);
    //   document.addEventListener("keypress", this.resetTimer, false);
    //   document.addEventListener("DOMMouseScroll", this.resetTimer, false);
    //   document.addEventListener("mousewheel", this.resetTimer, false);
    //   document.addEventListener("touchmove", this.resetTimer, false);
    //   document.addEventListener("MSPointerMove", this.resetTimer, false);
    // },
    // startTimer() {
    //   this.timeoutID = window.setTimeout(this.goInactive, 1200000);
    // },
    // resetTimer() {
    //   window.clearTimeout(this.timeoutID);
    //   this.goActive();
    // },
    // goInactive() {
    //   this.$store.dispatch("logout").then(() => {
    //     var elem = document.getElementById("freshchat-js-sdk");
    //     if (elem) {
    //       elem.parentNode.removeChild(elem);
    //       this.$router.push("/login");
    //     } else {
    //       this.$router.push("/login");
    //     }
    //   });
    // },
    // goActive() {
    //   this.startTimer();
    // }
  },
  created () {
    // this.setup()
  }
};
</script>
